var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarVisainfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.556,
    height: 13.571,
    viewBox: "0 0 13.556 13.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plane-alt",
    d: "M6.125,13.571H4.535L6.253,8.482H3.4l-.613.935a1.692,1.692,0,0,1-1.415.762H.036L1.28,6.786.027,3.393H1.369a1.691,1.691,0,0,1,1.414.759l.622.937h2.85L4.535,0h1.59A1.7,1.7,0,0,1,7.615.884L9.957,5.089h1.869A1.744,1.744,0,0,1,13.559,6.5a1.7,1.7,0,0,1-1.674,1.979H9.957L7.612,12.691a1.7,1.7,0,0,1-1.487.88Z",
    transform: "translate(-0.027)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarVisainfo);
export default __webpack_public_path__ + "static/media/sidebar-visainfo.822ae9f587ffecae0c28dfbd4cfc78a8.svg";
export { ForwardRef as ReactComponent };